import { deleteDatabaseItem } from "../../../services/database/deleteDatabaseItem";
import { Slide, SlideKey } from "../types/slideTypes";

export async function deleteSlide(lessonId: string, id: string) {

    const slide = await deleteDatabaseItem<Slide, SlideKey>("/slides", { lessonId, id })

    return slide
}